import { useModelsStore } from '~/stores/models'; // Assuming stores/models.ts is the correct path
import type { VehicleModel } from '~/stores/models'; // Import the type

export default defineNuxtPlugin({
  name: 'models-data-ssr', // Renamed for clarity
  async setup(nuxtApp) {
    // Skip this plugin to avoid Pinia initialization issues
    // Models will be loaded when needed by components
    console.log('[models-data-ssr] Plugin disabled to prevent Pinia initialization conflicts')
    return;
    
    // Wrap the logic in app:created to ensure Pinia is initialized
    nuxtApp.hooks.hook('app:created', async () => {
      // Wait for Pinia to be ready
      await nextTick()
      
      // Additional wait to ensure Pinia is fully initialized
      let retries = 0
      while (retries < 10) {
        try {
          const modelsStore = useModelsStore()
          if (modelsStore) break
        } catch (error) {
          // Pinia not ready yet, wait a bit more
          await new Promise(resolve => setTimeout(resolve, 100))
          retries++
          if (retries >= 10) {
            console.warn('[models-data-ssr] Pinia not ready after retries, skipping models initialization')
            return
          }
        }
      }
      
      const modelsStore = useModelsStore();

      if (process.server) {
        // console.log('[models-data-ssr] [Server] [app:created] Calling initialFetchModels.');
        await modelsStore.initialFetchModels();
        // The data fetched by useFetch (with key 'models-ssr-data') inside initialFetchModels
        // will automatically be part of nuxtApp.payload.data if successful.
      } 
      // No explicit client-side action needed here if initialFetchModels populates the store via useFetch and its payload.
      // When the store is used on the client, it will already have the data from SSR hydration.
      // However, if we want to be absolutely sure and handle cases where SSR might have missed it,
      // or for direct client-side navigation where this plugin runs again:
      // else if (process.client) {
      //   if (!modelsStore.isInitialized) {
      //     // console.log('[models-data-ssr] [Client] [app:created] Store not initialized, attempting to use payload or fetch.');
      //     const payloadData = nuxtApp.payload.data['models-ssr-data'] as VehicleModel[];
      //     if (payloadData) {
      //       // console.log('[models-data-ssr] [Client] [app:created] Hydrating from nuxtApp.payload.data.');
      //       modelsStore._setModelsInternal(payloadData);
      //     } else {
      //       // console.log('[models-data-ssr] [Client] [app:created] No payload data found for models-ssr-data, calling clientFetchModels.');
      //       // This will make a client-side request if SSR data is missing.
      //       // To strictly avoid client-side requests from this plugin, remove this else block.
      //       await modelsStore.clientFetchModels(); 
      //     }
      //   } else {
      //     // console.log('[models-data-ssr] [Client] [app:created] Store already initialized.');
      //   }
      // }
    });
  }
  // This plugin should run early. If it needs to run after Pinia is fully initialized,
  // you might wrap its logic in nuxtApp.hooks.hook('app:created', async () => { ... });
  // However, for calling a store action that uses useFetch, this direct setup is usually fine.
});